var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "lang-select" }, [
    _c(
      "span",
      {
        class: { active: _vm.language === "zh" },
        on: {
          click: function ($event) {
            return _vm.handleSetLanguage("zh")
          },
        },
      },
      [_vm._v("中文")]
    ),
    _vm._v(" "),
    _c("span", [_vm._v("/")]),
    _vm._v(" "),
    _c(
      "span",
      {
        class: { active: _vm.language === "en" },
        on: {
          click: function ($event) {
            return _vm.handleSetLanguage("en")
          },
        },
      },
      [_vm._v("En")]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }